var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.546,
    height: 18.549,
    viewBox: "0 0 18.546 18.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#aeb0b1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.293,16.037l-3.612-3.612a.869.869,0,0,0-.616-.254h-.59a7.531,7.531,0,1,0-1.3,1.3v.59a.869.869,0,0,0,.254.616l3.612,3.612a.866.866,0,0,0,1.228,0l1.025-1.025A.873.873,0,0,0,18.293,16.037ZM7.535,12.172a4.637,4.637,0,1,1,4.637-4.637A4.634,4.634,0,0,1,7.535,12.172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsearch);
export default __webpack_public_path__ + "static/media/Iconsearch.e30ec1fb.svg";
export { ForwardRef as ReactComponent };